module.exports = __webpack_public_path__ + "static/media/anmitsu.e472b4bd.jpg";